import { render, staticRenderFns } from "./PdfDownloadButton.vue?vue&type=template&id=f056f1ea&scoped=true&"
import script from "./PdfDownloadButton.vue?vue&type=script&lang=js&"
export * from "./PdfDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f056f1ea",
  null
  
)

export default component.exports